/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v7.2.1. DO NOT EDIT. DO NOT COMMIT.

import StringMetricType from '@mozilla/glean/private/metrics/string';

/**
 * UTM campaign
 *
 * Generated from `utm.campaign`.
 */
export const campaign = new StringMetricType({
  category: 'utm',
  name: 'campaign',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * UTM content
 *
 * Generated from `utm.content`.
 */
export const content = new StringMetricType({
  category: 'utm',
  name: 'content',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * UTM medium
 *
 * Generated from `utm.medium`.
 */
export const medium = new StringMetricType({
  category: 'utm',
  name: 'medium',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * UTM source
 *
 * Generated from `utm.source`.
 */
export const source = new StringMetricType({
  category: 'utm',
  name: 'source',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});

/**
 * UTM term
 *
 * Generated from `utm.term`.
 */
export const term = new StringMetricType({
  category: 'utm',
  name: 'term',
  sendInPings: ['accounts-events'],
  lifetime: 'ping',
  disabled: false,
});
